import type { UnauthApi } from '@/api';

type Merchant = NonNullable<
  NonNullable<
    Awaited<
      ReturnType<(typeof UnauthApi)['get:/wello/v1/allows/affiliate/merchants']>
    >['data']
  >['context']
>['contents'][number];

export type MerchantSectionType = Merchant['sectionType'];

const SECTION_ORDER: MerchantSectionType[] = [
  'LARGE_SHOPPING',
  'TRAVEL_STAY',
  'ETC',
];

export const groupMerchantsBySection = <
  T extends { sectionType: MerchantSectionType },
>(
  merchants: T[],
) =>
  SECTION_ORDER.map((sectionType) => ({
    sectionType,
    merchants: merchants.filter(
      (merchant) => merchant.sectionType === sectionType,
    ),
  })).filter((section) => section.merchants.length > 0);
